/* Build gallery — filters, show-more, detail dialog. */
(function () {
  'use strict';
  document.querySelectorAll('[data-gallery]').forEach(function (root) {
    var items = Array.prototype.slice.call(root.querySelectorAll('.gal__item'));
    var note = root.querySelector('.gal__note');
    var initial = parseInt(root.dataset.initial, 10) || 9, limit = initial;
    var make = '', finish = '';
    var more = root.querySelector('[data-gal-more]'), moreWrap = root.querySelector('[data-gal-more-wrap]');
    var empty = root.querySelector('[data-gal-empty]'), status = root.querySelector('[data-gal-status]');
    function apply() {
      var shown = 0, matched = 0;
      items.forEach(function (it) {
        var ok = (!make || it.dataset.make === make) && (!finish || it.dataset.finish === finish);
        if (ok) matched++;
        var vis = ok && matched <= limit;
        it.hidden = !vis; if (vis) shown++;
      });
      moreWrap.hidden = matched <= limit;
      empty.hidden = matched > 0;
      if (note) note.hidden = matched === 0;
      if (status) status.textContent = matched + (matched === 1 ? ' build' : ' builds') + ' shown';
    }
    root.addEventListener('click', function (e) {
      var c = e.target.closest('[data-f-make]');
      if (c) {
        make = c.dataset.fMake; limit = initial;
        root.querySelectorAll('[data-f-make]').forEach(function (b) { b.setAttribute('aria-pressed', b === c); });
        apply();
      }
    });
    var fs = root.querySelector('[data-f-finish]');
    if (fs) fs.addEventListener('change', function () { finish = fs.value; limit = initial; apply(); });
    if (more) more.addEventListener('click', function () {
      var firstNew = items.filter(function (i) { return i.hidden; })[0];
      limit += initial; apply();
      if (firstNew && !firstNew.hidden) firstNew.querySelector('button').focus();
    });
    apply();

    var dlg = root.querySelector('[data-gal-dialog]'), body = root.querySelector('[data-gal-body]');
    root.addEventListener('click', function (e) {
      var o = e.target.closest('[data-gal-open]'); if (!o) return;
      var tpl = o.parentNode.querySelector('template[data-gal-detail]');
      body.innerHTML = ''; body.appendChild(tpl.content.cloneNode(true));
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
    });
    root.querySelector('[data-gal-close]').addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
  });
})();
